import { Column, Entity, PrimaryGeneratedColumn, ManyToOne, OneToMany } from "typeorm"
import { RuleActionType, RuleType, RuleNotificationInterval } from "../../enumerations";
import { bigint } from "../../transofrmers/BigInt";
import { ContractTariff } from "./ContractTariff"
import { RuleHistory } from "./RuleHistory"


@Entity()
export class Rule {

	@PrimaryGeneratedColumn({ name:"id" })
	id?: number;

	@ManyToOne(() => ContractTariff, contract_tariff => contract_tariff.rules, { eager: true, onDelete:'CASCADE' })
  tariff!: ContractTariff

	@Column({ type: "bigint", nullable:false, transformer:bigint })
  value!: number

	@Column()
	timeframe!: number

	@Column()
	actiontype!: RuleActionType

	@Column()
	actiondetails!: string;

	@Column()
	device_type!: string

	@Column()
	ruletype!: RuleType

	@OneToMany(() => RuleHistory, ruleHistory => ruleHistory.rule)
  history!: RuleHistory

	@Column()
	notification_interval!: RuleNotificationInterval

}